exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nimg.screenshot[data-v-72d4c9af] {\n    width: 32em;\n}\ndiv.center[data-v-72d4c9af] {\n    text-align: center;\n}\n", ""]);

